export default "__VITE_ASSET__eed3a226__"